<script setup lang="ts">
import JsBarcode from 'jsbarcode'

const props = withDefaults(defineProps<{
  value: string
  options?: JsBarcode.Options
  label?: string
}>(), {
  options: () => ({}),
  label: undefined,
})

const barcodeSource = ref('')

function renderBarcode() {
  if (!props.value) {
    barcodeSource.value = ''
    return
  }

  const element = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  JsBarcode(element, props.value, {
    format: 'CODE128',
    width: 1,
    height: 32,
    displayValue: false,
    background: 'transparent',
    lineColor: 'currentColor',
    margin: 0,
    ...props.options,
  })

  element.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
  const markup = new XMLSerializer().serializeToString(element)
  barcodeSource.value = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(markup)}`
}

onMounted(renderBarcode)
watch(
  [() => props.value, () => props.options],
  renderBarcode,
  { deep: true, flush: 'post' },
)
</script>

<template>
  <img
    v-if="barcodeSource"
    :src="barcodeSource"
    role="img"
    :aria-label="label ?? `Barcode ${value}`"
  >
</template>
